
import { Component, Vue } from "vue-property-decorator";
import { ISMSForm } from "@/models/SMS";
import { SMHorizontalQuestionnaire, SMUser } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { formatDate } from "@/utils/dates";

@Component({
  components: {
    StepZeroSMS: () => import("./components/StepZeroSMS.vue"),
    StepOneSMS: () => import("./components/StepOneSMS.vue"),
    StepTwoSMS: () => import("./components/StepTwoSMS.vue"),
    StepThreeSMS: () => import("./components/StepThreeSMS.vue"),
    StepFourSMS: () => import("./components/StepFourSMS.vue"),
  },
})
export default class HorizontalQuestionnaire extends Vue {
  step = 0;

  setStep(step: number) {
    this.step = step;
  }

  successDialog = false;
  errorMessage: string | null = null;
  loading = false;

  form: ISMSForm = {
    number_of_employees: "",
    number_of_employees_change_date: "",
    number_of_employees_change_reason: "",
    number_of_employees_change_details: "",
  };

  files: File[] = [];

  get isOpen() {
    return SMHorizontalQuestionnaire.isOpen;
  }

  close() {
    SMHorizontalQuestionnaire.close();
  }

  success() {
    this.updateSmsTask();
  }

  setFiles(files: File[]) {
    this.files = files;
  }

  updateSmsTask() {
    this.loading = true;
    this.form.number_of_employees_change_date = formatDate(
      this.form.number_of_employees_change_date
    );
    const formData = new FormData();
    this.setFormDataFields(formData);
    this.setFormDataFiles(formData);
    const url = API_ROUTES.FINISH_REPORT_EMPLOYEES_NUMBER_CHANGE(this.taskId);
    this.axios
      .post(url, formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then(() => {
        this.close();
        this.successDialog = true;
        this.$router.push(SMUser.basePath + "/home");
      });
  }

  setFormDataFields(formData: FormData) {
    const keys = Object.keys(this.form) as (keyof ISMSForm)[];
    keys.forEach((key) => {
      formData.append(key, String(this.form[key]));
    });
  }

  setFormDataFiles(formData: FormData) {
    this.files.forEach((file) => {
      formData.append("file", file);
    });
  }

  closeAlert() {
    this.errorMessage = null;
  }

  get taskId() {
    return SMHorizontalQuestionnaire.taskId;
  }
}
